import React, { useRef } from "react";
import "./index.less";

type FileType = "privacy" | "user";
interface Props {
  fileType: FileType;
  fileUrl: string;
}
const ViewPdf: React.FC<Props> = (props: Props) => {
  const { fileType, fileUrl } = props;
  const iframeRef = useRef<any>(null);
  return (
    <div className={`pdf-content ${fileType === "privacy" ? "privacy-content" : "user-content"}`}>
      <iframe
        ref={iframeRef}
        className="pdf-content-frame"
        src={fileUrl}
        frameBorder="0"
        width="100%"
        height="100%"
      ></iframe>
    </div>
  );
};
export default ViewPdf;
